import styles from './SecondaryButton.module.css'
import classNames from 'classnames'
import type { SecondaryVariantTypes } from '../../Button.types'
import ButtonContent from '../../Content/ButtonContent'
import ButtonTag from '../../Tag/ButtonTag'

const SecondaryButton = (props: SecondaryVariantTypes) => {
  const { color = 'blue', size, isUppercase = false } = props

  const blockClasses = classNames({
    [styles.SecondaryButton]: true,
    [styles[`SecondaryButton--is-${color}`]]: true,
    [styles[`SecondaryButton--is-${size}`]]: true,
    [styles[`SecondaryButton--is-uppercase`]]: isUppercase,
  })

  return (
    <ButtonTag props={props} internalClass={blockClasses}>
      <ButtonContent {...props} noMinWidth />
    </ButtonTag>
  )
}

export default SecondaryButton
